export default __webpack_public_path__ + "static/media/eq-sp.e3e5688f.svg";